import React, { useState } from 'react';
import { TextField, Button, Box, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createFactureAchat } from '../../../api/factureAchatApi';

const CreerFactureAchat = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fournisseurId: '',
    date: new Date().toISOString().split('T')[0],
    montant: '',
    statut: 'brouillon',
    description: '',
  });
  const [fournisseurs, setFournisseurs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Exemple de chargement des fournisseurs (à adapter selon ton API)
  React.useEffect(() => {
    const fetchFournisseurs = async () => {
      try {
        const response = await fetch('/api/fournisseurs');
        const data = await response.json();
        setFournisseurs(data);
      } catch (err) {
        console.error("Erreur lors du chargement des fournisseurs:", err);
      }
    };
    fetchFournisseurs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createFactureAchat(formData);
      navigate('/factures-achat');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Créer une facture d'achat
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Fournisseur</InputLabel>
          <Select
            name="fournisseurId"
            value={formData.fournisseurId}
            onChange={handleChange}
            required
          >
            {fournisseurs.map((fournisseur) => (
              <MenuItem key={fournisseur.id} value={fournisseur.id}>
                {fournisseur.nom}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Date"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Montant (€)"
          type="number"
          name="montant"
          value={formData.montant}
          onChange={handleChange}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          multiline
          rows={4}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Statut</InputLabel>
          <Select
            name="statut"
            value={formData.statut}
            onChange={handleChange}
            required
          >
            <MenuItem value="brouillon">Brouillon</MenuItem>
            <MenuItem value="payée">Payée</MenuItem>
            <MenuItem value="en attente">En attente</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreerFactureAchat;
